import { QRCodeSVG } from "qrcode.react";
import { Copy, Mail, MessageCircle, Send } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { useLang } from "../i18n/LanguageContext";

export const ShareDialog = ({ open, onOpenChange, url, onCopy }) => {
  const { t } = useLang();
  const text = t.share.text;
  const enc = encodeURIComponent;
  const targets = [
    { id: "whatsapp", label: "WhatsApp", icon: MessageCircle, href: `https://wa.me/?text=${enc(`${text} ${url}`)}` },
    { id: "telegram", label: "Telegram", icon: Send, href: `https://t.me/share/url?url=${enc(url)}&text=${enc(text)}` },
    { id: "email", label: "Email", icon: Mail, href: `mailto:?subject=SYNrise&body=${enc(`${text} ${url}`)}` },
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="share-dialog" data-lenis-prevent className="max-w-sm rounded-[28px] border-white/10 bg-surface text-zinc-100">
        <DialogTitle className="font-display text-xl">{t.share.dialogTitle}</DialogTitle>
        <DialogDescription className="text-zinc-400">{t.share.dialogSub}</DialogDescription>
        <div className="mx-auto mt-2 rounded-3xl bg-zinc-50 p-4" data-testid="share-qr">
          <QRCodeSVG value={url} size={168} bgColor="#FAFAFA" fgColor="#07090E" level="M" />
        </div>
        <div className="grid grid-cols-3 gap-2">
          {targets.map(({ id, label, icon: Icon, href }) => (
            <a key={id} href={href} target="_blank" rel="noopener noreferrer" data-testid={`share-target-${id}`}
              className="flex flex-col items-center gap-2 rounded-2xl border border-white/5 bg-white/[0.03] py-3 text-xs text-zinc-300 transition-colors hover:border-gold/30 hover:text-gold">
              <Icon className="h-5 w-5" />
              {label}
            </a>
          ))}
        </div>
        <button onClick={onCopy} data-testid="share-copy-link-button"
          className="flex h-12 items-center justify-between gap-3 rounded-full border border-white/10 bg-white/[0.04] pl-5 pr-1.5 text-left transition-colors hover:border-gold/40">
          <span className="truncate font-mono text-xs text-zinc-300" data-testid="share-url">{url}</span>
          <span className="flex h-9 shrink-0 items-center gap-2 rounded-full bg-gold px-4 text-xs font-semibold text-ink">
            <Copy className="h-3.5 w-3.5" /> {t.share.copy}
          </span>
        </button>
      </DialogContent>
    </Dialog>
  );
};
